<mat-form-field>
  <mat-label>
    {{ to.label | translate }} @if (to.required) {
    <span class="required" aria-required="true">*</span>
    }
  </mat-label>

  <mat-select [formControl]="formControl" (selectionChange)="to.change && to.change(field, $event)">
    @if (to.options | async; as options) { @for (option of options; track option) {
    <mat-option [value]="option[to.valueProp]">{{ option[to.labelProp] | translate }}</mat-option>
    } } @else {
    <mat-option disabled></mat-option>
    }
  </mat-select>

  @if (formControl.errors) {
  <mat-error>
    <app-gwall-hint [gwall]="formControl.errors.gwall"></app-gwall-hint>
  </mat-error>
  }
</mat-form-field>
